import { DATA_COVERAGE, INDUSTRIES } from '@/config/constants';
import { useCountryParam, usePlan } from 'utils/hooks';
import { Capitalize } from 'components/Text';
import { DATA_SOURCES } from 'utils/metrics';
import { Link } from 'react-router-dom';
import NoDataSection from './NoDataSection';
import SerialComma from './SerialComma';
import { mixpanelTrack } from 'utils/app';
import { useEffect } from 'react';
import { views } from '@/copy';

function Message({ dataSource }) {
    const planQuery = usePlan();
    const { currentCountryParam, mutateToWithCountryParam } = useCountryParam();
    const { label, supportedGeos } = DATA_SOURCES[dataSource];

    useEffect(() => {
        mixpanelTrack(`No${label}Data`, {
            country: currentCountryParam,
            dataSource: label,
        });
    }, [currentCountryParam, label]);

    const currentGeoIsSupported =
        currentCountryParam && supportedGeos?.includes(currentCountryParam);
    const supportedIndustries = Object.keys(
        DATA_COVERAGE[currentCountryParam]?.[dataSource] || {},
    ).filter(
        (cat1) =>
            planQuery.plan?.industry?.includes(cat1) &&
            INDUSTRIES.includes(cat1),
    );

    if (currentGeoIsSupported) {
        return supportedIndustries.length < 1 ? (
            <>{label} data is not available for this industry.</>
        ) : (
            <>
                {label} data is only available for the{' '}
                <SerialComma>
                    {supportedIndustries.map((cat) => (
                        <Capitalize key={cat}>{cat}</Capitalize>
                    ))}
                </SerialComma>{' '}
                industr{supportedIndustries?.length > 1 ? 'ies' : 'y'}.
            </>
        );
    }
    return (
        <>
            {label} data is only available for the{' '}
            <SerialComma>
                {supportedGeos.map((geo) => (
                    <Link
                        key={geo}
                        to={mutateToWithCountryParam({
                            search: `?country=${geo}`,
                        })}
                    >
                        {geo === 'GLOBAL' ? 'Global' : geo}
                    </Link>
                ))}
            </SerialComma>{' '}
            market{supportedGeos?.length > 1 ? 's' : ''}.
        </>
    );
}

function NoDataSourceMarketCoverage({ dataSource, ...props }) {
    return (
        <NoDataSection
            heading={views.noDataAvailable}
            message={<Message dataSource={dataSource} />}
            {...props}
        />
    );
}

export default NoDataSourceMarketCoverage;
